import { numberFormat } from '@/utils/priceFormat.js'
import { isNumber } from '@/utils/tool'

// 金额格式化
export default {
  filters: {
    formatNumber(val, region) {
      return isNumber(val) ? numberFormat(val, region) : val
    },
  },
}
